/* ============================================
   CART ICON — Header shopping bag + badge (Shopify)
   ============================================ */

(function() {
  'use strict';

  window.Brume = window.Brume || {};

  var badge;

  // ── Create Icon Element ─────────────────────

  function createCartButton() {
    var btn = document.createElement('button');
    btn.className = 'header-cart';
    btn.id = 'headerCartBtn';
    btn.setAttribute('aria-label', 'Open bag');
    btn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>' +
        '<line x1="3" y1="6" x2="21" y2="6"/>' +
        '<path d="M16 10a4 4 0 0 1-8 0"/>' +
      '</svg>' +
      '<span class="header-cart-badge" id="cartBadge">0</span>';
    return btn;
  }

  // ── Update Badge ────────────────────────────

  function updateCartBadge() {
    if (!badge) return;
    var count = Brume.Cart.getCartCount();
    badge.textContent = count;

    if (count > 0) {
      badge.classList.add('has-items');
      // Pop animation
      badge.classList.remove('cart-badge-pop');
      void badge.offsetWidth; // force reflow
      badge.classList.add('cart-badge-pop');
      setTimeout(function() { badge.classList.remove('cart-badge-pop'); }, 300);
    } else {
      badge.classList.remove('has-items');
    }
  }

  // ── Init ────────────────────────────────────

  function initCartIcon() {
    var header = document.querySelector('.header');
    if (!header) return;

    var cartBtn = createCartButton();
    var existingCta = header.querySelector('.header-cta');
    var menuToggle = header.querySelector('.mobile-menu-toggle');

    // Create .header-actions wrapper
    var actions = document.createElement('div');
    actions.className = 'header-actions';

    // Move existing CTA into wrapper (if it exists, like on index page)
    if (existingCta) {
      existingCta.parentNode.insertBefore(actions, existingCta);
      actions.appendChild(existingCta);
    } else {
      // Buy page — insert before mobile toggle
      if (menuToggle) {
        header.insertBefore(actions, menuToggle);
      } else {
        header.appendChild(actions);
      }
    }

    // Append cart button into actions
    actions.appendChild(cartBtn);

    // Store badge reference
    badge = document.getElementById('cartBadge');

    // Click opens drawer
    cartBtn.addEventListener('click', function() { Brume.openDrawer(); });

    // Keep badge in sync
    Brume.Cart.onCartChange(updateCartBadge);

    // Initial badge state
    updateCartBadge();
  }

  // ── Expose API ──────────────────────────────

  window.Brume.initCartIcon = initCartIcon;
  window.Brume.updateCartBadge = updateCartBadge;

})();
